import { Injectable } from '@angular/core';
import { GridLayoutService } from '@irb-common/interfaces/grid-layout.service';
import { ComViewAssetClassesDialogComponent } from './com-view-asset-classes-dialog.component';

@Injectable({
    providedIn: 'root'
})
export class ComViewAssetClassesDialogGridLayoutService implements GridLayoutService<ComViewAssetClassesDialogComponent> {
    constructor() {}

    getFrameworkComponents() {
        return {};
    }

    getColumnDefs(_parent: ComViewAssetClassesDialogComponent) {
        return [{
            headerName: 'Schwab Asset Classes',            
            field: 'label',
            flex: 1,
            sortable: false,
            showRowGroup: true,
            cellRenderer: 'agGroupCellRenderer',
            cellRendererParams: {
                suppressCount: true
            }
        }];
    }
}
